import algoliaClient from "algoliasearch/lite";

const searchAlgolia = (idx, keywords, options = {}) => {
  const client = algoliaClient(algoliaAppId, algoliaAppKey);
  const index = client.initIndex(idx);

  return index.search(keywords, options).then((res) => res.hits);
};

export default searchAlgolia;
